const AUTO_ADD_VARIANT_ID = 50586868089145;

let isManagingGift = false;
let manageGiftTimeout = null;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
  }


  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      // ensureProductInCart();
      manageFreeGift();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// function ensureProductInCart() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       const hasOtherItems = cart.items.some(item => item.id !== AUTO_ADD_VARIANT_ID);
//       const hasAutoProduct = cart.items.some(item => item.id === AUTO_ADD_VARIANT_ID);
//       console.log("hasOtherItems:",hasOtherItems);
//       console.log("hasAutoProduct:",hasAutoProduct);

//       if (hasOtherItems && !hasAutoProduct) {
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: AUTO_ADD_VARIANT_ID, quantity: 1 })
//         })
//         .then(() => {
//           fetch("/cart/update.js", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//         updates: {},
//         sections: ["cart-drawer", "cart-icon-bubble"]
//     })
// }).then((res) => res.json()).then((cartData) => {
//     document.querySelector("cart-drawer").renderContents(cartData);
//     document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
// });
//         });
//       }
//     });
// }

async function getCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

async function addFreeMagnesium() {
  console.log("Adding free vitamin d...");
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: AUTO_ADD_VARIANT_ID, quantity: 1 }),
  });
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"]
    })
}).then((res) => res.json()).then((cartData) => {
    document.querySelector("cart-drawer").renderContents(cartData);
    document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
});
}

async function removeFreeMagnesium() {
  const cart = await getCart();
  const giftItem = cart.items.find(item => item.id === AUTO_ADD_VARIANT_ID);
  if (giftItem) {
    console.log("Removing free vitamin d...");
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
    });
    fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"]
    })
}).then((res) => res.json()).then((cartData) => {
    document.querySelector("cart-drawer").renderContents(cartData);
    document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
});
  }
}

async function manageFreeGift() {
  if (isManagingGift) return; // prevent concurrent execution

  isManagingGift = true;
  try {
    const cart = await getCart();

    const hasGift = cart.items.some(i => i.id === AUTO_ADD_VARIANT_ID);
    const nonGiftItems = cart.items.filter(i => i.id !== AUTO_ADD_VARIANT_ID);
    const totalQuantity = nonGiftItems.reduce((sum, item) => sum + item.quantity, 0);

    if (totalQuantity >= 1 && !hasGift) {
      await addFreeMagnesium();
    } else if (totalQuantity < 1 && hasGift) {
      await removeFreeMagnesium();
    }
  } finally {
    isManagingGift = false;
  }
}




document.addEventListener("DOMContentLoaded", () => {
  async function checkLastItem() {
    const cart = await fetch("/cart.js").then(res => res.json());

    if (cart.items.length === 1) {
      const lastItem = cart.items[0];
      if (lastItem.handle === "apple-cider-vinegar-gummies-gift") {
        await fetch("/cart/clear.js", { method: "POST" });
        location.reload();
      }
    }
    if (cart.items.length === 1) {
      const lastItem = cart.items[0];
      if (lastItem.handle === "vitamin-d-gift") {
        await fetch("/cart/clear.js", { method: "POST" });
        location.reload();
      }
    }

    if (cart.items.length === 1) {
      const lastItem = cart.items[0];
      if (lastItem.handle === "magnesium-500-mg-gift") {
        await fetch("/cart/clear.js", { method: "POST" });
        location.reload();
      }
    }
  }

  // // Detect cart changes automatically
  // const observer = new MutationObserver(() => {
  //   checkLastItem();
  //   manageFreeGift();
  // });

  // const cartDrawer = document.querySelector("cart-drawer");
  // if (cartDrawer) {
  //   observer.observe(cartDrawer, { childList: true, subtree: true });
  // }

  // checkLastItem();
  // manageFreeGift();
  const observer = new MutationObserver(() => {
    // debounce: group rapid DOM changes
    clearTimeout(manageGiftTimeout);
    manageGiftTimeout = setTimeout(() => {
      checkLastItem();
      manageFreeGift();
    }, 150); // 150–300ms is usually plenty
  });

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // initial run on page load
  checkLastItem();
  manageFreeGift();

});

